export const AVAIL_RQ = 'AVAIL_RQ';
export const AVAIL_RCV = 'AVAIL_RCV';
export const AVAIL_ERR = 'AVAIL_ERR';
export const AVAIL_SHOW_RATE = 'AVAIL_SHOW_RATE';
export const AVAIL_SHOW_STATE = 'AVAIL_SHOW_STATE';
export const AVAIL_CRITERIA_CHANGE = 'AVAIL_CRITERIA_CHANGE';
export const AVAIL_ROOM_CHANGE = 'AVAIL_ROOM_CHANGE';
export const AVAIL_NO_ROOMS_CHANGE = 'AVAIL_NO_ROOMS_CHANGE';
export const AVAIL_NO_CHILD_CHANGE = 'AVAIL_NO_CHILD_CHANGE';
export const AVAIL_CHILD_AGE_CHANGE = 'AVAIL_CHILD_AGE_CHANGE';
export const AVAIL_RANGE_CHANGE = 'AVAIL_RANGE_CHANGE';
export const AVAIL_DISPLAY_NO_OF_NIGHTS_CHANGE = 'AVAIL_DISPLAY_NO_OF_NIGHTS_CHANGE';
export const AVAIL_CUSTOMER_KEY_CHANGE = 'AVAIL_CUSTOMER_KEY_CHANGE';
export const AVAIL_CUSTOMER_RQ = 'AVAIL_CUSTOMER_RQ';
export const AVAIL_CUSTOMER_CHANGE = 'AVAIL_CUSTOMER_CHANGE';

export const AVAIL_MUITHEME_CHANGE = 'AVAIL_MUITHEME_CHANGE';


// WEBPACK FOOTER //
// ./src/actions/ActionType.js